export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50 to-accent-100/30"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-200/15 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 全网同步</span>
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight mb-4">
              羞羞歪歪漫画 - 免费全集无删减下拉式阅读平台
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-heading mb-5">
              海量漫画 · 即时更新 · 畅快阅读
            </p>

            <div className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-[600px] mx-auto lg:mx-0 space-y-2 mb-6">
              <p>
                羞羞歪歪漫画在线观看入口官网，为您提供最便捷的在线看漫画体验。平台汇聚了热血、恋爱、搞笑、悬疑、奇幻等全品类漫画资源，所有作品均为免费全集无删减版本，支持下拉式阅读模式，无需翻页即可一气呵成。
              </p>
              <p>
                每日同步更新最新话，确保您不错过任何精彩剧情。无论是经典日漫、国漫新作还是小众精品，这里都是您的专属漫画入口。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-600">20000+</div>
                <div className="text-xs text-foreground-500">部漫画资源</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500">全网同步</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-secondary-600">免费无删减</div>
                <div className="text-xs text-foreground-500">下拉式阅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 font-medium text-sm rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap no-underline cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                分类索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20manga%20comic%20reading%20atmosphere%20with%20stylized%20art%20panels%20floating%20in%20soft%20golden%20light%2C%20artistic%20illustration%20style%2C%20coral%20and%20amber%20color%20palette%2C%20Japanese%20manga%20aesthetic%20meets%20modern%20clean%20design%2C%20dynamic%20composition%20with%20speech%20bubbles%20and%20action%20lines%2C%20warm%20cream%20background%20with%20subtle%20texture%2C%20immersive%20reading%20environment%20vibe&width=960&height=720&seq=hero-visual-2026&orientation=landscape"
                alt="羞羞歪歪漫画在线观看入口 - 漫画阅读视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}